import React, { Component } from 'react';

import styles from './LoopeLogo.styles';

const LOGO_PATH_DATA = `M845.4,191 C829.5,191 763.4,191 763.4,191 L763.4,164.9 C784,150.1 799.6,139.7 822.4,139.7 C831.2,139.7 838.3,132.6 838.3,123.8 C838.3,115 831.2,107.9 822.4,107.9 C798.5,107.9 780.3,115.8 763.4,126.4 L763.4,123.1 L763.4,91.6 L763.4,38.6 L841,38.6 C863.8,38.6 862.9,7.1 842.1,7.1 C821.3,7.1 760.1,7.1 760.1,7.1 C744.1,7.1 731.2,20 731.2,36 L731.2,148.7 C702,169.2 666.6,189.5 598.6,190.3 L598.6,178 C598.6,178 598.6,178 598.6,178 L598.6,151.2 C605.7,152.1 612.5,152.5
619.1,152.5 C653.5,152.5 681.2,140.6 697.2,118.3 C712.7,96.8 714.5,68.7 701.9,45 C679,3.3 604.3,-20.9 502.9,27.9 C483.2,11.6 458.4,2.6 432.8,2.6 C399.3,2.6 358.9,25 308.9,58.9 L308.9,58.9 C291.1,32.8 265.4,5 222.6,2.8 C163.2,-0.2 111.7,45.1 107.4,104.4 C105.6,129.6 112.1,153.7 125.9,174.2 L125.9,174.2 C99.1,185.7 76,188.9 55.5,188.9 L31.5,188.9 L31.7,20.7 C31.7,-2.5 0.3,-2 0.3,19.4 C0.3,35.8 0.1,197.9 0.1,197.9 C0.1,210.3 10.1,220.3 22.5,220.3 L55.5,220.3 C82.9,220.3 113.3,214.8 148.4,198.5
C148.4,198.5 148.4,198.5 148.4,198.5 C167.9,214.2 192.2,222.7 217.2,222.7 C249.1,222.7 284.9,199.6 335.2,164 C335.2,164 335.2,164 335.2,164 C354.8,192.3 383.6,222.7 432.9,222.7 C493.6,222.7 543,173.3 543,112.6 C543,91.3 537,70.8 525.5,53.1 C525.5,53.1 525.5,53.1 525.5,53.1 C532.9,48.5 554.3,40.2 566.7,38.1 L566.7,204.5 C566.7,204.8 566.6,205.1 566.6,205.4 C566.3,214.2 573.2,221.5 582,221.8 C586.3,221.9 590.5,222 594.6,222 C660.6,222 700.9,205.4 731.2,186.7 L731.2,193.1 C731.2,209 744.1,222
760,222 L845.3,222.1 C862.8,222.5 861.3,191 845.4,191 Z M598.6,34.6 C634.6,29.6 661.5,38.5 673.9,60.1 C680.8,73 679.8,88.3 671.5,99.9 C658.9,117.4 632.4,124.4 598.6,119.3 L598.6,34.6 Z M138.6,112.9 C138.6,69.5 173.9,34.2 217.3,34.2 C242.7,34.2 262.7,47 283.2,76.9 C278.7,80.1 274.1,83.3 269.3,86.6 C231.8,112.9 193.1,140.1 154.7,160.4 C144.2,146.9 138.6,130.1 138.6,112.9 Z M318.5,137.6 C280.4,164.6 241.6,191.5 217.2,191.5 C204.2,191.5 191.6,188.3 180.2,182.3 C216.6,161.9 252.5,136.8 287.2,112.4
L288.3,111.6 C292,109 295.7,106.4 299.4,103.8 C302.2,108.7 304.9,113.6 307.6,118.5 C311.2,124.7 314.8,131.2 318.5,137.6 L318.5,137.6 Z M344.3,119.4 C341.3,114.1 335.2,103.2 335.2,103.2 C332,97.5 328.8,91.7 325.5,85.9 L325.5,85.9 C365.5,58.7 405.8,34.3 432.9,34.3 C445.5,34.3 457.8,37.3 468.9,43 L468.9,43 C423.3,64.8 382.4,92.5 344.3,119.4 Z M432.9,191.6 C404.5,191.6 382.7,178 360.8,146.2 C402.2,117 446.6,87.1 495.5,65.4 L495.5,65.4 C505.9,79 511.5,95.8 511.5,113 C511.6,156.3 476.3,191.6
432.9,191.6 Z`;

type Props = {
  fill?: string;
  width?: string;
  height?: string;
};

const DEFAULT_PROPS: Props = {
  fill: '#fff'
};

export default class LoopeLogo extends Component {

  props: Props;
  static defaultProps = DEFAULT_PROPS;

  render() {
    const viewBox = '0 0 ' + this.props.width + ' ' + this.props.height
    return (
      <div style={styles.container}>
        <svg width={this.props.width} height={this.props.height} viewBox='0 0 858 223'>
          <path d={LOGO_PATH_DATA} fill={this.props.fill}/>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/loope-logo/LoopeLogo.js